import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Form} from 'antd';

import classNames from 'classnames';
import find from 'lodash/find';

import InfoLabel from '../InfoLabel/InfoLabel';
import messages from './messages';

import './BaseFormItem.css';

function BaseFormItem({
  className,
  style,
  field,
  children,
  label,
  info,
  labelRight,
  labelBold,
  required,
  dependencies,
  labelCol,
  wrapperCol,
  colon = false,
  layout,
  validateFirst = false,
  rules = [],
  popoverMaxWidth,
  popoverPlacement,
  valuePropName,
  noStyle,
  extra,
  normalize,
  preserve,
  hidden = false,
  getValueFromEvent,
  getValueProps,
  initialValue,
}) {
  if (required && !find(rules, {required: true})) {
    rules.unshift({
      required: true,
      message: <FormattedMessage {...messages.required} />,
    });
  }

  const infoLabel = label && (
    <InfoLabel
      label={label}
      labelBold={labelBold}
      info={info}
      secondary={labelRight}
      maxWidth={popoverMaxWidth}
      placement={popoverPlacement}
    />
  );

  return (
    <Form.Item
      className={classNames('BaseFormItem', className)}
      style={style}
      name={field}
      rules={rules}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
      colon={colon}
      layout={layout}
      label={infoLabel}
      dependencies={dependencies}
      validateFirst={validateFirst}
      valuePropName={valuePropName}
      noStyle={noStyle}
      extra={extra}
      preserve={preserve}
      hidden={hidden}
      getValueFromEvent={getValueFromEvent}
      getValueProps={getValueProps}
      normalize={normalize}
      initialValue={initialValue}
    >
      {children}
    </Form.Item>
  );
}

BaseFormItem.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  field: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  info: PropTypes.node,
  labelCol: PropTypes.object,
  wrapperCol: PropTypes.object,
  colon: PropTypes.bool,
  layout: PropTypes.oneOf(['horizontal', 'vertical', 'inline']),
  label: PropTypes.node,
  labelRight: PropTypes.node,
  labelBold: PropTypes.bool,
  required: PropTypes.bool,
  rules: PropTypes.array,
  dependencies: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  validateFirst: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  popoverPlacement: PropTypes.string,
  popoverMaxWidth: PropTypes.string,
  valuePropName: PropTypes.string,
  noStyle: PropTypes.bool,
  extra: PropTypes.node,
  preserve: PropTypes.bool,
  hidden: PropTypes.bool,
  normalize: PropTypes.func,
  getValueFromEvent: PropTypes.func,
  getValueProps: PropTypes.func,
  initialValue: PropTypes.any,
};

export default BaseFormItem;
